// extracted by mini-css-extract-plugin
export default {"container":"B4v4aI"};